import React from 'react';
import Link from 'gatsby-link'

import styles from './Apply.module.scss';

const ApplyInterest = (props) => (
  <div className={styles.Apply}>
    <h2 className="h2">{props.title}</h2>
    { props.buttonTitle ?
        <a className={ styles.Button } href={ props.buttonUrl } target="_blank">{ props.buttonTitle }</a> :
        <Link to="/interest-form/" className={styles.Button}>Learn More</Link>
    }
  </div>
)

export default ApplyInterest;



// WEBPACK FOOTER //
// ./src/components/Apply-Interest/index.js